import Axios, { AxiosRequestHeaders, InternalAxiosRequestConfig } from 'axios';

import { API_URL } from '../../config';
import storage from '../../utils/storage';
import { useVerComo } from '../../stores/verComo';

function authRequestInterceptor(config: InternalAxiosRequestConfig) {
    const token = storage.getToken();
    
    if(!config.headers) {
      config.headers = {} as AxiosRequestHeaders;
    }

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    
    config.headers.Accept = 'application/json';

    // "Ver como lojista/comprador" do dono/adm: o back passa a tratar a requisição como aquele
    // cargo (permissões e dados). De outro perfil, o back ignora.
    const verComo = useVerComo.getState().verComo;
    if (verComo) config.headers['X-Ver-Como'] = verComo;
    
    return config;
}

export const axios = Axios.create({ baseURL: API_URL });

axios.interceptors.request.use(authRequestInterceptor);
axios.interceptors.response.use( (response) => response.data, (error) => Promise.reject(error) );